import { useSearchParams } from 'react-router-dom';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { QrCode } from '../../../../../../components/qr-code/qr-code';
import { getOrigin } from '../../../../../../helpers/path';
import { useLang } from '../../../../../../hooks/use-lang';
import s from './qr-code-modal.module.css';

export const QrCodeModal = (props: ModalProps) => {
  const { t } = useLang();
  const [params] = useSearchParams();
  const qrId = params.get('qrId');
  const qrName = params.get('qrName');
  const code = params.get('code');
  const isAttached = params.get('isAttached') == '1';

  const dynamicCodeContent = (
    <>
      <label>{t('QR-код {{qrName}}', { qrName })}</label>
      {code ? (
        <span className={s.code}>
          {t('Код:')} {code}
        </span>
      ) : (
        <QrCode data={qrId ? `${getOrigin()}/qr/${qrId}` : undefined} />
      )}
    </>
  );

  const staticCodeContent = <QrCode data={qrId ? `${getOrigin()}/qr/${qrId}` : undefined} />;

  return (
    <Modal {...props} title={isAttached ? '' : t('Ваш QR-код')} className={s.feature}>
      {isAttached && <label>{t('Данный ключ был использован')}</label>}
      {!isAttached && (code ? dynamicCodeContent : staticCodeContent)}
    </Modal>
  );
};
